/**
 * Workspace Search Schema
 *
 * Shared Zod schema for workspace route search params.
 * Used for URL-based preview state and tag filtering.
 *
 * @module features/workspace/utils/workspaceSearchSchema
 */

import { z } from 'zod';

/**
 * Search params schema for workspace routes
 *
 * - tag: Filter by tag ID
 * - preview: Item ID to preview
 * - type: Item type ('table' or 'linked_table')
 * - expanded: Whether preview overlay is expanded
 */
export const workspaceSearchSchema = z.object({
  tag: z.string().optional(),
  preview: z.string().optional(),
  type: z.enum(['table', 'linked_table']).optional(),
  expanded: z.coerce.boolean().optional(),
  folder: z.string().uuid().optional(),
});

export type WorkspaceSearchParams = z.infer<typeof workspaceSearchSchema>;
